import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["cardLoader", "cardContent", "questionModal"];

  connect() {
    // Guard to ensure loadCardContent is only called once per connection cycle
    // Prevents duplicate loads due to multiple triggers (mutation observer, event, etc.)
    this._cardContentLoaded = false;
    if (this.hasCardLoaderTarget && this.hasCardContentTarget) {
      this._onStreamConnected = () => {
        this.loadCardContent();
      };

      // Also listen for turbo stream reconnects
      const sources = this.element.querySelectorAll("turbo-cable-stream-source");

      // Create mutation observer for above elements which will listen for changes
      this._observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "connected"
          ) {
            this.loadCardContent();
          }
        });
      });

      sources.forEach((source) => {
        this._observer.observe(source, { attributes: true });
      });
    }
  }

  disconnect() {
    if (this._onStreamConnected) {
      document.removeEventListener(
        "turbo:cable-stream-source-connected",
        this._onStreamConnected
      );
      this._onStreamConnected = null;
    }
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  loadCardContent() {
    // Only load card content once per connection cycle
    // This prevents duplicate fetches if multiple triggers occur
    if (this._cardContentLoaded) return;
    this._cardContentLoaded = true;

    const cardName = this.element.dataset.cardName;
    const cardLoader = this.cardLoaderTarget;
    const cardContent = this.cardContentTarget;
    const startDate = this.element.dataset.startDate;
    const endDate = this.element.dataset.endDate;
    cardLoader.style.display = "block";

    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    });

    fetch(`/educator_dashboard/${cardName}?${params.toString()}`)
      .then(response => response.text())
      .then(html => {
        cardContent.innerHTML = html;
        cardContent.dispatchEvent(new Event('card:content:loaded', { bubbles: true }));
      })
      .catch(error => {
        console.error("Error fetching data:", error);
        cardContent.innerHTML = "Error fetching data: " + error.message;
      })
      .finally(() => {
        cardLoader.style.display = "none";
        cardContent.style.opacity = "1";
      });
  }

  openQuestionModal(event){
    event.preventDefault();
    this.questionModalTarget.classList.remove("hidden");
    document.addEventListener("click", this.closeQuestionModal.bind(this));
  }

  closeQuestionModal(event){
    if(event.target.id === 'questionModal'){
      this.questionModalTarget.classList.add("hidden");
    }
  }

  updateDate(event) {
    const startDateInput = document.getElementById("start-date");
    const endDateInput = document.getElementById("end-date");
  
    // Get the previous valid values from data attributes
    const previousStartDate = startDateInput.dataset.previousValue || startDateInput.value;
    const previousEndDate = endDateInput.dataset.previousValue || endDateInput.value;
  
    const startDate = new Date(startDateInput.value);
    const endDate = new Date(endDateInput.value);
  
    if (startDate && endDate) {
      if (endDate < startDate) {
        alert("End date must be greater than the start date.");
  
        // Revert the field value to its previous valid value, formatted for the input type
        if (event.target.id === "end-date") {
          endDateInput.value = this.formatDateForInput(previousEndDate);
        } else if (event.target.id === "start-date") {
          startDateInput.value = this.formatDateForInput(previousStartDate);
        }
  
        return;
      }
    }
  
    // If validation passes, update the previous valid values in data attributes
    startDateInput.dataset.previousValue = startDateInput.value;
    endDateInput.dataset.previousValue = endDateInput.value;
  
    const form = document.getElementById("calendar-form");
    form.requestSubmit();
  }
  
  formatDateForInput(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Return empty string if the date is invalid
  
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
  
    const month = months[date.getMonth()]; // Get abbreviated month name
    const day = date.getDate(); // Day with leading zero
    const year = date.getFullYear(); // Full year
  
    // Return the formatted date in M d, yy format
    return `${month} ${day}, ${year}`;
  }

  toggleMenu(event) {
    event.preventDefault();
    const menu = document.getElementById("reset-div-close-card-img-container");
    const menuIcon = event.target;
    if (menu) {
      if (menu.style.display === "none" || menu.style.display === "") {
        menu.style.display = "flex";
        menuIcon.classList.add("rotated"); 
      } else {
        menu.style.display = "none";
        menuIcon.classList.remove("rotated");
      }
    }
  }
}
